import { getList, getOne, getPortion } from './getData'
import { setCreate, setDelete, setUpdate } from './setData'

const pitches = {
  namespaced: true,
  state: {
    loading: false,
    listPitches: [],
    listPortionPitches: [],
    listSelectPitches: [],
    idSelected: '',
    stadiumSelect: '',
    pitchSelected: {},
    stadiumsReference: []
  },
  mutations: {
    updateList: (state, list) => {
      state.listPitches = list || []
      state.listSelectPitches = []
      if (list) {
        list.forEach(item =>
          state.listSelectPitches.push({
            text: item.name,
            value: item._id
          })
        )
      }
    },
    updateStadium: (state, stadium) => {
      state.stadiumSelect = stadium
    },
    clearPortion: state => {
      state.listPortionPitches = []
    },
    updatePortion: (state, list) => {
      if (list && list.length > 0) {
        list.forEach(item => state.listPortionPitches.push(item))
      }
    },
    updateOne: (state, one) => {
      state.pitchSelected = one
      state.idSelected = one._id
    },
    updateLoading: (state, loading) => (state.loading = loading),
    updateClearOne: state => {
      state.pitchSelected = {}
      state.idSelected = ''
    }
  },
  actions: {
    setInit: async ({ commit, state }, idStadium) => {
      await getList(commit, idStadium)
    },
    setPortion: async ({ commit, state }, arrayStadium) => {
      await getPortion(commit, arrayStadium)
    },
    setCreateNew: async ({ commit, dispatch }, { idStadium, pitch }) => {
      await setCreate(idStadium, pitch)
      getList(commit, idStadium)
      if (idStadium) dispatch('stadiums/setInit', idStadium, { root: true })
    },
    setUpdatePitch: async ({ commit, dispatch }, { idStadium, pitch }) => {
      await setUpdate(idStadium, pitch)
      getList(commit, idStadium)
      if (idStadium) dispatch('stadiums/setInit', idStadium, { root: true })
    },
    setDeletePitch: async ({ commit, dispatch }, { idStadium, idPitch }) => {
      await setDelete(idStadium, idPitch)
      getList(commit, idStadium)
      if (idStadium) dispatch('stadiums/setInit', idStadium, { root: true })
    },
    setOne: ({ commit }, { idStadium, idPitch }) =>
      getOne(commit, idStadium, idPitch),
    setClearOne: ({ commit }) => {
      commit('updateClearOne')
    },
    setStadium: ({ commit }, stadium) => commit('updateStadium', stadium)
  }
}

export default pitches
